"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedLanguages = exports.appDefaultLanguage = void 0;
var appDefaultLanguage = 'pl';
exports.appDefaultLanguage = appDefaultLanguage;
var supportedLanguages = ['pl', 'en', 'de'];
exports.supportedLanguages = supportedLanguages;